import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Globe, Check } from 'lucide-react';
import { useI18n } from '@/i18n/I18nContext';
import { LANG } from '@/constants/testIds';

const itemTestIdMap = {
  en: LANG.itemEn,
  es: LANG.itemEs,
};

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, supported } = useI18n();
  const current = supported.find((s) => s.code === lang) || supported[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid={LANG.trigger}
        className="group inline-flex items-center gap-2 border border-[#C9A24E]/40 px-3 py-2 text-xs uppercase tracking-[0.18em] text-[#C9A24E] hover:bg-[#C9A24E]/10 transition-colors"
        aria-label="Change language"
      >
        <Globe size={14} className="opacity-80" />
        {compact ? current.label : `${current.label}`}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#0A1A2F] border border-[#C9A24E]/30 text-[#F2F5F8] rounded-none min-w-[160px]"
      >
        {supported.map((s) => {
          const active = s.code === lang;
          return (
            <DropdownMenuItem
              key={s.code}
              data-testid={itemTestIdMap[s.code]}
              onClick={() => setLang(s.code)}
              className={`flex items-center justify-between cursor-pointer rounded-none px-3 py-2 text-sm focus:bg-[#C9A24E]/10 focus:text-[#C9A24E] ${
                active ? 'text-[#C9A24E]' : 'text-[#F2F5F8]'
              }`}
            >
              <span>
                <span className="font-medium tracking-wider mr-2">{s.label}</span>
                <span className="opacity-70 text-xs">{s.name}</span>
              </span>
              {active && <Check size={14} className="text-[#C9A24E]" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
